import { array, boolean, enums, object, optional, string, defaulted, union } from 'superstruct'
import { AppId, Asset, Country, Currency } from './primitives.js'

export const PaymentMethodType = enums([
  'apple_pay',
  'bank',
  'card',
  'google_pay',
  'ideal',
  'imps',
  'interacetransfer',
  'paypal',
  'pix',
  'revolut_pay',
  'robinhood',
  'upi',
  'venmo',
])

export const PaymentMethodFilter = object({
  appId: optional(AppId),
  country: optional(Country),
  cryptoAsset: optional(Asset),
  currency: optional(Currency),
  orderType: optional(enums(['buy', 'sell'])),
  type: PaymentMethodType,
})

export const PaymentMethod = object({
  apps: optional(array(object({ id: AppId, enabled: boolean() }))),
  countries: optional(array(object({ id: Country, enabled: boolean() }))),
  currencies: optional(array(object({ id: Currency, enabled: boolean() }))),
  id: string(),
  orderTypes: defaulted(array(enums(['buy', 'sell'])), ['buy']),
  type: union([PaymentMethodType, array(PaymentMethodType)]),
})
